module.exports = __webpack_public_path__ + "media/proximanova-semibold.ec46605a.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/proximanova-semibold.ttf
// module id = 107
// module chunks = 9